/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForTemplateAwsProvider extends models.ScheduleExecutionParameterForTemplateBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForTemplateAwsProvider");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForTemplateAwsProvider.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForTemplateAwsProvider>): ScheduleExecutionParameterForTemplateAwsProvider {
        let obj = Object.assign(new ScheduleExecutionParameterForTemplateAwsProvider(), model);
        ScheduleExecutionParameterForTemplateAwsProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForTemplateAwsProvider>): ScheduleExecutionParameterForTemplateAwsProvider {
        if (!model) return null;
        return ScheduleExecutionParameterForTemplateAwsProvider.newInstance(<ScheduleExecutionParameterForTemplateAwsProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForTemplateAwsProvider) {
        if (!obj) return;

        models.ScheduleExecutionParameterForTemplateAwsProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForTemplateAwsProvider): boolean {
        if (models.ScheduleExecutionParameterForTemplateBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForTemplateAwsProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The region of the cloud account where it needs to be executed.
     */
    region: string;

}
